import React from 'react';
import {listSharedExperiments} from '../services/SharedExperimentService'
import SharedExperimentRow from "./components/SharedExperimentRow"
import Pagination from '@mui/material/Pagination';
import { Link } from "react-router-dom";


class SharedExperimentsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            token: props.jwtToken
        };
        this.handlePagination = this.handlePagination.bind(this);
        this.updateData = this.updateData.bind(this);
    }

    updateData(page=0){
        this.setState({data: []});
        listSharedExperiments(this.state.token, page)
            .then(response =>
                {
                    this.setState({data: response});
                }
            );
    }

    handlePagination(event,value){
        this.updateData(value -1)
    }

    componentDidMount() {
        this.updateData();
    }

    render() {
    var renderedRows = [];
    for (var i = 0; i < this.state.data.itemsOnPage; i++) {
        renderedRows.push(<SharedExperimentRow key={i}
            id={this.state.data.data[i].experimentId}
            name={this.state.data.data[i].experimentDto.name}
            ownerMail={this.state.data.data[i].ownerMail}
            rights={this.state.data.data[i].rights}
            status={this.state.data.data[i].experimentDto.state}
            handler={this.updateData}
            jwtToken={this.state.token}
            />
        );
    }

    return (
    <>
        <div className="row" style={{marginLeft: "4%", marginRight: "4%"}}>
            <h1>
                <Link to="/">
                    <span title="Return to experiment listing">All experiments/</span>
                </Link>
                Shared experiments
            </h1>

            <div style={{ height: 430 }}>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th style={{width: "25%"}}>Name</th>
                            <th style={{width: "15%"}}>Owner</th>
                            <th style={{width: "10%"}}>Rights</th>
                            <th style={{width: "10%"}}>State</th>
                            <th style={{width: "10%"}}>Show</th>
                            <th style={{width: "10%"}}>Edit</th>
                            <th style={{width: "10%"}}>Share</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderedRows}
                    </tbody>
                </table>
            </div>
            <Pagination sx={{'& .MuiButtonBase-root': {fontSize: "16px"},
            '& .MuiSvgIcon-root': {width: "25px", height: "25px"}
            }} count={this.state.data.totalPages} onChange={this.handlePagination} color="primary"/>
        </div>
    </>
    );
    }
}

export default SharedExperimentsView;
